<script setup>
import AppButton from '@modules/ui/app-button.vue'
</script>
<template>
  <div class="not-found">
    <div class="not-found__content">
      <h1>404</h1>
      <p>Page not found</p>
      <app-button router>Back to home page</app-button>
    </div>
  </div>
</template>
